import React, { useCallback } from "react";

import CaseIcon from "./CaseIcon";
import ToolbarComponent from "../ToolbarComponent.jsx";

function Header({
    onFlip,
    onReset,
    Dyn,
    onStackClick,
    onIconsClick,
    onCountClick,
    dynElemPlayContainer,
    toolsContainer,
    onCaptureImage,
    startStopAnnotationClick,
    clearAllAnnotations,
}) {
    const showActionButtons = dynElemPlayContainer?.canShowActionButtons;
    const disableResetButton = dynElemPlayContainer?.canDisableResetButton;
    // const disableFlipButton = dynElemPlayContainer?.canDisablePlotViewButton;
    const options = dynElemPlayContainer?.options || {};
    const onClick = useCallback(
        (type, action, eventType ) => {
            let handled = true;
            switch (type) {
                case "flip":
                    onFlip();
                    break;
                case "reset":
                    onReset();
                    break;
                case "spread":
                    onStackClick();
                    break;
                case "icons":
                    onIconsClick();
                    break;
                case "count":
                    onCountClick();
                    break;
                case "undo":
                    Dyn.undoManager.undo();
                    break;
                case "redo":
                    Dyn.undoManager.redo();
                    break;
                case "ImagePNG":
                    onCaptureImage();
                    break;
                case "clearAllAnnotations":
                    clearAllAnnotations();
                    break;
                default:
                    if( action?.m === 'annotate') {
                        // see also ToolbarComponent.menuItemToPlotAction( action ), ToolbarComponent.startStopAnnotationClick()
                        startStopAnnotationClick( {
                            menuValue: type,
                            method: action.m,
                            constructor: action.c,
                            controlType: action.t,
                            eventType: eventType,
                        });
                        handled = true;
                    }
                    break;
            }
            return handled;
        },
        [options, onFlip, onReset, onStackClick, onIconsClick, onCountClick]
    );
    return (
        <div className="tde-d-flex tde-elem-play-header tde-toolbar-panel">
            <ToolbarComponent
                Dyn={Dyn}
                toolsContainer={toolsContainer}
                sampleMode={{ isSampleMode: false }}
                columns={[]}
                mode="jr"
                setFinalClass={() => {}}
                // PlayView only props
                playViewOn={true}
                playViewMenu={showActionButtons? 'JR_PLAY': 'JR_PLAY_INITIAL'}
                playViewCaseIcon={
                    <CaseIcon Dyn={Dyn} isActive={options.isIconOnly} />
                }
                playViewDisableMenus={disableResetButton}
                playViewActiveMenus={{
                    spread: options.isSpreadOut,
                    count: options.isShowingCount,
                    icons: options.isIconOnly,
                }}
                playViewMenuItemClick={onClick}
            ></ToolbarComponent>
        </div>
    );
}

export default Header;
